import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { HistoricCrystallisationPage } from '../../Models/Domains/Drawdown/HistoricCrystallisationPage';

declare var IS_RUNNING_IN_APP_POOL;

export class HistoricCrystallisationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, minRow: number, maxRow: number): Promise<HistoricCrystallisationPage, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/HistoricCrystallisation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, minRow: minRow, maxRow: maxRow }

    return AjaxWrapper.get<HistoricCrystallisationPage, any>(url, data);
  }
}

